import React, { useEffect, useState } from 'react';
import '../authentication/AuthRedesign.scss';
import axios from 'axios';
import { API_ENDPOINTS, CONSTS, ENDPOINTS } from '../utils/endpoints';
import { useDispatch, useSelector } from 'react-redux';
import { getOnboardingData, setOnboardingData } from '../../../redux/onboardingSlice';

const CreateAccount = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => getOnboardingData(state));
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [formErrors, setFormErrors] = useState({});
  const logo = require('../../assets/usernurture-logo.png');

  const handleFormUpdate = (event) => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    dispatch(setOnboardingData({ [target.name]: value }));
  };

  const registerUser = () => {
    setIsLoading(true);
    setFormErrors({});
    axios
      .post(API_ENDPOINTS.REGISTER, {
        email: data.email,
        password: data.password,
        password_confirmation: data.password_confirmation,
        terms: data.terms
      })
      .then((response) => {
        localStorage.setItem(CONSTS.AUTH_TOKEN, response.data.token);
        window.location.href = ENDPOINTS.ONBOARDING;
      })
      .catch((error) => {
        try { setFormErrors(JSON.parse(error.response.data.error)); }
        catch (e) { setFormErrors({ base: ['Something went wrong. Please try again.'] }); }
      })
      .finally(() => setIsLoading(false));
  };

  const validEmail = (email) => /\S+@\S+\.\S+/.test(email || '');
  const mismatch = data.password_confirmation && data.password !== data.password_confirmation;

  useEffect(() => {
    setIsDisabled(
      !data.email || !data.password || !data.password_confirmation ||
      !data.terms || data.password !== data.password_confirmation || !validEmail(data.email)
    );
    localStorage.setItem(CONSTS.AUTH_TOKEN, '');
  }, [data]);

  const err = (k) => (formErrors[k] ? <p className="un-auth__err">{[].concat(formErrors[k]).join(', ')}</p> : null);

  return (
    <div className="un-auth">
      <div className="un-auth__form">
        <div className="un-auth__top">
          <a href={ENDPOINTS.ROOT}><img src={logo} alt="UserNurture" className="un-auth__logo" /></a>
        </div>

        <div className="un-auth__body">
          <h1 className="un-auth__q">Create your workspace</h1>
          <p className="un-auth__sub">Start building interactive guides your customers actually finish. Free to try — no credit card.</p>

          <a href="/users/auth/google_oauth2?type=sign_up" className="un-auth__sso" style={{ marginBottom: 10 }}>
            <img src="/assets/google.png" alt="" /> Continue with Google
          </a>

          <div className="un-auth__divider">or sign up with email</div>

          <div className="un-auth__field">
            <div className="un-auth__label">Work email</div>
            <input type="email" name="email" placeholder="you@company.com" value={data.email || ''} onChange={handleFormUpdate} />
            {err('email')}
          </div>
          <div className="un-auth__field">
            <div className="un-auth__label">Password</div>
            <input type="password" name="password" placeholder="At least 8 characters" value={data.password || ''} onChange={handleFormUpdate} />
            {err('password')}
          </div>
          <div className="un-auth__field">
            <div className="un-auth__label">Confirm password</div>
            <input type="password" name="password_confirmation" placeholder="Re-enter password" value={data.password_confirmation || ''} onChange={handleFormUpdate} />
            {mismatch ? <p className="un-auth__err">Passwords don't match.</p> : err('password_confirmation')}
          </div>

          <label style={{ display: 'flex', gap: 9, alignItems: 'flex-start', fontSize: 13, color: '#5A6B7E', margin: '2px 0 4px', cursor: 'pointer' }}>
            <input type="checkbox" name="terms" checked={!!data.terms} onChange={handleFormUpdate} style={{ width: 16, height: 16, marginTop: 1 }} />
            <span>I agree to the <a href="https://usernurture.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a> and <a href="https://usernurture.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</span>
          </label>
          {err('base')}

          <button className="un-auth__btn un-auth__btn--primary" onClick={registerUser} disabled={isDisabled || isLoading} style={{ marginTop: 8 }}>
            {isLoading ? 'Creating…' : 'Create account'}
          </button>

          <div className="un-auth__center">Already have an account? <a href={ENDPOINTS.LOGIN}>Sign in</a></div>
        </div>

        <div className="un-auth__foot">
          <span>© 2026 UserNurture</span>
          <span><a href="https://usernurture.com/terms">Terms</a> · <a href="https://usernurture.com/privacy">Privacy</a></span>
        </div>
      </div>

      {/* Brand panel — placeholder testimonial + logo wall; swap for real customers before launch. */}
      <div className="un-auth__brand">
        <div className="un-auth__quote">
          <div className="un-auth__quote-logo">NORTHWIND</div>
          <div className="un-auth__quote-text">"We replaced a 20-page PDF with three UserNurture walkthroughs. New-customer setup tickets dropped by half in the first month — people just follow the steps and finish."</div>
          <div className="un-auth__quote-by"><b>Priya Nadella</b><span>, Head of Customer Success, Northwind</span></div>
        </div>
        <div className="un-auth__logowall">
          <span>ACME</span><span>Northwind</span><span>Lumen</span><span>Brightpath</span><span>Vertex</span>
          <span>Cedar</span><span>Meridian</span><span>Kova</span><span>Fielding</span><span>Orbit</span>
        </div>
      </div>
    </div>
  );
};

export default CreateAccount;
